import React from "react";

/**
 * Ramdev Steel Furniture brand logo (owner-provided).
 * Use `size` for width in px; height auto-scales via aspect ratio.
 */
export const LOGO_URL = "https://customer-assets-7cd3h4nn.emergentagent.net/job_ramdev-steel-pro/artifacts/x1udmauo_file_00000000b990720b86801761cd0b2a46.png";

export default function Logo({ size = 40, className = "", showText = false, textClass = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <img
        src={LOGO_URL}
        alt="Ramdev Steel Furniture"
        width={size}
        height={size}
        style={{ width: size, height: size }}
        className="object-contain select-none"
        loading="eager"
        fetchPriority="high"
      />
      {showText && (
        <div className={`flex flex-col leading-tight ${textClass}`}>
          <span className="font-display font-semibold text-slate-900 text-[15px] md:text-base">Ramdev Steel</span>
          <span className="hidden md:block text-[10px] tracking-[0.2em] uppercase text-slate-500 font-grotesk">Furniture & Fabrication</span>
        </div>
      )}
    </div>
  );
}
